import React, {Component} from "react"
import {Row} from "@irati/ui/src/Layout"

import {FormattedMessage} from "@irati/utils/lang"
import TextArea from "@irati/ui/src/FormItem/TextArea"
import Flex from "@irati/ui/src/Flex"
import Button from "@irati/ui/src/Button"
import {Body, H1} from "@irati/ui/src/Typography"
import Spacing from "@irati/ui/src/Spacing"

interface Props {
  id: string
  welcomeEmail: string
  welcomeEmailMaxLength: number
  handleWelcomeEmailChange: (str: string) => void
  useDefault: () => string
  saveWelcomeEmail: () => void
}

class EditWelcomeEmailContent extends Component<Props> {
  render() {
    const {welcomeEmail, welcomeEmailMaxLength, handleWelcomeEmailChange, useDefault, saveWelcomeEmail} = this.props
    const charactersOverTheLimit = welcomeEmail.length - welcomeEmailMaxLength

    return (
      <Flex direction="column" width="75%">
        <H1 marginBottom={4}>
          <FormattedMessage id="admin.components.welcomeEmail.headerTwo.text" />
        </H1>
        <Body>
          <FormattedMessage id="admin.components.welcomeEmail.headerFour.text" />
        </Body>
        <Row>
          <Spacing marginTop={2}>
            <TextArea
              id="customWelcomeEmailField"
              hideLabel
              onChange={handleWelcomeEmailChange}
              maxLength={welcomeEmailMaxLength}
              value={welcomeEmail}
              rows={6}
            />
          </Spacing>
        </Row>
        {welcomeEmail.length >= welcomeEmailMaxLength && (
          <p>
            <FormattedMessage id="admin.components.welcomeEmail.charactersOverTheLimit" values={{count: charactersOverTheLimit}} />
          </p>
        )}
        <Flex marginTop={2}>
          <Button marginRight onClick={useDefault}>
            <FormattedMessage id="admin.components.welcomeEmail.styledButton.useDefault" />
          </Button>
          <Button primary onClick={saveWelcomeEmail}>
            <FormattedMessage id="admin.components.welcomeEmail.styledButton.save" />
          </Button>
        </Flex>
      </Flex>
    )
  }
}

export default EditWelcomeEmailContent
